import { useEffect, useState } from 'react';
import configment from '@adc/configment';
const useCurrentLocation = () => {
    const [location, setLocation] = useState(null);
    useEffect(() => {
        setLocation(configment.get('REQUEST_LOCATION', null));
    }, []);
    return location;
};
export default useCurrentLocation;
//# sourceMappingURL=index.js.map